declare var SimpleBar;
declare var loggedTc;

namespace AgerLMS.WebSite {

    export interface WebSiteWidgetRequest {
    }

    @Serenity.Decorators.registerClass()
    export class WebSiteWidget extends Serenity.Widget<WebSiteWidgetRequest> {

        constructor(element: JQuery, opt: WebSiteWidgetRequest) {
            super(element, opt);

            $('.dropdown-menu .simple-bar').each((i, e) => new SimpleBar(e));
        }
    }

    export interface VideoPlayerAfterLoadHandlerRequest {
        fileVideoPlayer: any;
        lessonId: number;
        videoUserLastSecond?: number;
        videoSettings?: string;
    }

    export class VideoPlayerAfterLoadHandler {

        fileVideoPlayer: any;
        lessonId: number;
        constructor(opt: VideoPlayerAfterLoadHandlerRequest) {
            var self = this;
            this.fileVideoPlayer = opt.fileVideoPlayer;
            this.lessonId = opt.lessonId;

            var videoSettings = <VideoPlayerSettings>JSON.parse((opt.videoSettings as any).replaceAll("&quot;", '"'));

            if (opt.videoUserLastSecond)
                this.fileVideoPlayer.currentTime(opt.videoUserLastSecond);

            this.fileVideoPlayer.on("pause", function(){
                self.updateUserTime();
            });

            //video sonlanınca
            this.fileVideoPlayer.on('ended', function() {
                // var entity = <Logging.UserEventLogRow>{};
                // entity.EntityId = self.lessonId;
                // entity.EntityType = 2; //2 Lesson
                // entity.EventType = "LearningStatusTrue"; //2 Lesson
                // Logging.UserEventLogService.Create({ Entity: entity }, ()=> {
                //     Q.notifySuccess("Tebrikler Dersi Bitti, Diğer Derse Geçiyorsunuz!");
                //     window.setTimeout(()=> {
                //         self.fileVideoPlayer.dispose();
                //         window.location.reload();
                //     });
                // });
            });
    
            this.fileVideoPlayer.watermark({
                image: Q.resolveUrl('~/upload/' + videoSettings.WatermarkImage),
                url: 'https://agersoft.com'
            });
            
            this.fileVideoPlayer.newoverlay({
                contentOfOverlay: (videoSettings.TcText as any).replaceAll("[TC]", loggedTc),
                changeDuration: videoSettings.Speed ? videoSettings.Speed * 1000 : 10000
            });

            if (videoSettings.VisibilityChange == true) this.visibilitychange();
        }

        private visibilitychange() {
            var self = this;
            var focused = true; 
            var player_state = false;
            document.addEventListener("visibilitychange", function () {
            focused = !focused;
            if (!focused) {
                if (typeof self.fileVideoPlayer !== 'undefined') { 
                    if(self.fileVideoPlayer.paused()) player_state=true;
                       self.fileVideoPlayer.pause(); 
                    }
                } else {
                    if(player_state!=true) {
                       self.fileVideoPlayer.play();
                    }
                }
            });
        }

        private updateUserTime() {
            var entity = {} as Logging.LessonWatchLogRow;
            entity.LessonId = this.lessonId;
            entity.LastSecond = this.fileVideoPlayer.currentTime();
            entity.TotalSecond = this.fileVideoPlayer.duration();

            AgerLMS.Logging.LessonWatchLogService.Create({
                Entity : entity
            }, ()=> {
                //SweetAlert.swal_success(Q.text("WebSite.Text.Successfull"), Q.text("WebSite.Text.Successfull"));
            }, {
                onError: (e) => {
                    Swal.fire({
                        icon: 'error',
                        title: Q.text("WebSite.Text.Error"),
                        text: e.Error.Message
                      })
                }
            });
        }

        // var myPlayer = videojs('videoPlayer');
        // myPlayer.on('timeupdate', function() {
        // console.log(this.currentTime());
        // });
    }
}